// import React from "react";
// import Tool from "./Tool";
//
// export default class ZoomInTool extends Tool {
//
//   constructor(props) {
//     super(props, 20, 20, "zoomOut", true);
//   }
//
//   registerEvents() {
//     return {
//       click: this.click.bind(this)
//     };
//   }
//
//   click(e) {
//     const c = this.toolbar.document.props.parent;
//     c.zoomOut();
//   }
//
import React from "react";
import Tool from "./Tool";
import { observer } from "mobx-react";
import { observable } from "mobx";

@observer
export default class ZoomTool extends Tool {
  @observable dragging = false;
  @observable dragStart = {};
  @observable selection = {};
  selecting = false;
  moving = false;

  constructor(props) {
    super(props, 20, 20, "zoomOut", true);
  }

  registerEvents() {
    return {
      mousemove: this.mouseMove.bind(this),
      mousedown: this.mouseDown.bind(this),
      mouseup: this.mouseUp.bind(this)
    };
  }

  mouseDown(e) {
    if (e.button === 0) {
      e.preventDefault();
      e.stopPropagation();

      this.dragging = true;
      this.selecting = true;
      this.dragStart = {
        x: e.clientX,
        y: e.clientY
      };
    }
  }

  startMove(x, y) {
    this.dragging = true;
    this.moving = true;
    this.dragStart = {
      x,
      y
    };
  }

  mouseMove(e) {
    if (this.dragging) {
      e.preventDefault();
      e.stopPropagation();
      const deltaX = e.clientX - this.dragStart.x;
      const deltaY = e.clientY - this.dragStart.y;

      if (this.selecting) {
        let x, y, w, h;

        if (deltaX < 0) {
          x = e.clientX;
          w = this.dragStart.x - x;
        } else {
          x = this.dragStart.x;
          w = deltaX;
        }
        if (deltaY < 0) {
          y = e.clientY;
          h = this.dragStart.y - y;
        } else {
          y = this.dragStart.y;
          h = deltaY;
        }
        this.selection = {
          top: y,
          left: x,
          width: w,
          height: h,
          hidden: false
        };
      }
    }
  }

  mouseUp(e) {
    const doWeMove =
      e.clientX - this.dragStart.x > 0 && e.clientY - this.dragStart.y > 0;

    if (this.dragging) {
      this.dragging = false;

      if (this.selecting) {
        this.selecting = false;
        this.comeFromSelection = true;
      }
      if (this.moving) this.moving = false;

      this.selection.hidden = true;
    }

    if(e.button === 0) {
      if (doWeMove) this.zoomOutArea();
      else this.zoomOut();
    }
  }

  zoomOut() {
    const c = this.toolbar.document.props.parent;
    c.zoomOut();
  }

  zoomOutArea() {
    const c = this.toolbar.document.props.parent;
    c.zoomOutArea({
      x: this.selection.left,
      y: this.selection.top,
      w: this.selection.width,
      h: this.selection.height
    });
  }

  renderAction() {
    return (
      <div
        key={115}
        style={{
          position: "absolute",
          top: this.selection.top,
          left: this.selection.left,
          width: this.selection.width,
          height: this.selection.height,
          background: "rgba(71, 100, 249, .2)",
          border: "1px solid rgb(71, 100, 249)",
          visibility: this.selection.hidden ? "hidden" : "visible"
        }}
      />
    );
  }

  renderTool() {
    return (
      <g>
        <circle cx={8} cy={8} r={7} strokeWidth={2} />
        <line x1={5} y1={7.5} x2={11} y2={7.5} strokeWidth={1} />
        <line x1={13} y1={13} x2={20} y2={20} strokeWidth={2} />
      </g>
    );
  }

  getCursor() {
    return "zoom-out";
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/tools/ZoomOutTool.js